import download from 'downloadjs';
import PatientFileUploadModel from '@/Models/PatientFileUploadModel';
import BaseService from '../BaseService';
import { PatientFileUploadRequest } from './mappers/PatientFileUploadRequests';
import {
  PatientFileUploadResponse,
  PatientFileUploadsResponse
} from './mappers/PatientFileUploadResponses';

class PatientFileUploadService extends BaseService {
  getPatientUploadsExportDataByGroup(exportRequest, fileName) {
    return this.backend('post', 'admin/uploads/export/', exportRequest, {
      responseType: 'blob'
    }).then(response => {
      download(
        response.data,
        `${fileName}.zip`,
        response.headers['content-type']
      );
    });
  }

  getMyPatientFileUploads() {
    return this.backend('my/patient/uploads').then(response =>
      PatientFileUploadsResponse(response.data)
    );
  }

  /**
   * Add Patient File Uploads -- backend
   * @param {PatientFileUploadModel[]} PatientFileUploads
   * @returns {Promise<PatientFileUploadModel[]>}
   * @memberof PatientFileUploadService
   */
  CreateMyPatientFileUpload(PatientFileUpload) {
    return this.backend(
      'post',
      'my/patient/uploads',
      PatientFileUploadRequest(PatientFileUpload)
    ).then(response => PatientFileUploadResponse(response.data));
  }

  /**
   * Delete current user's patient file upload -- backend
   * @param {string} guid PatientFileUpload id
   * @returns {Promise}
   * @memberof PatientFileUploadService
   */
  deleteMyPatientFileUpload(guid) {
    return this.backend('delete', `my/patient/uploads/${guid}`);
  }
}
export default new PatientFileUploadService();
